<!-- Template du composant Location Step Onboarding -->
<div class="bg-gradient-to-br from-blue-50 via-white to-indigo-50 dark:from-slate-900 dark:via-slate-900 dark:to-slate-900 p-4">
  <div class="max-w-5xl mx-auto">
    <!-- Barre de progression -->
    <app-progress-bar [currentStep]="3" [totalSteps]="6"></app-progress-bar>

    <!-- Titre -->
    <h2 class="text-base font-bold mb-1 mt-2">
      Où se trouve votre entreprise ?
    </h2>
    <p class="text-gray-600 dark:text-gray-400 text-xs mb-3">
      Nous allons analyser votre zone pour vous proposer des opportunités
      personnalisées
    </p>

    <!-- Sélection de l'adresse -->
    <div class="bg-white dark:bg-slate-800 rounded-lg p-4 mb-3">
      <app-location-picker
        (addressSelected)="onAddressSelected($event)"
        [showMap]="true"
        [mapHeight]="'300px'"
        [preselectedAddress]="selectedAddress || undefined"
      ></app-location-picker>
    </div>

    <!-- Boutons de navigation -->
    <div class="flex justify-between mb-2 mt-3">
      <button
        (click)="goBack()"
        class="flex items-center gap-2 px-4 py-1.5 text-sm font-medium rounded-lg transition-colors bg-gray-200 dark:bg-slate-700 text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-slate-600 hover:text-gray-900 dark:hover:text-white dark:text-white"
      >
        ← Précédent
      </button>

      <button
        [disabled]="!selectedAddress"
        (click)="continue()"
        class="flex items-center gap-2 px-4 py-1.5 text-sm font-medium rounded-lg transition-all"
        [ngClass]="{
          'bg-indigo-600 hover:bg-indigo-700 text-white shadow-md dark:shadow-slate-900/50 hover:shadow-lg dark:shadow-slate-900/50 cursor-pointer':
            selectedAddress,
          'bg-gray-300 text-gray-500 dark:text-gray-400 cursor-not-allowed': !selectedAddress,
        }"
      >
        Confirmer cette adresse
      </button>
    </div>
  </div>
</div>
